import { section as sectionData } from "shared/data";
import { section as dataSection } from "shared/data/section";
import { useEditionValue } from "shared/lib/edition";
import { useGetHomeAsPath } from "shared/lib/router";

import { page as HomePage } from "scmp-app/pages/home";
import { page as NewslettersPage } from "scmp-app/pages/newsletters";
import { page as SectionPage } from "scmp-app/pages/section";

export const useStylePageLink = () => {
  const as = sectionData.style.urlAlias;
  const { pathname, query } = SectionPage.route({
    appBarVariant: "scmp/magazines-style",
    entityId: dataSection.style.entityId,
    slide: "main",
  });
  return { as, pathname, query };
};

export const useHomePageLink = () => {
  const edition = useEditionValue();
  const as = useGetHomeAsPath();
  const { pathname, query } = HomePage.route({
    edition,
    slide: "main",
  });
  return { as, pathname, query };
};

export const useNewslettersPageLink = () => {
  const { pathname } = NewslettersPage.route({});
  const url = new URL(location.href);
  url.pathname = pathname;
  url.searchParams.set("defaultCheckedEntityIds", "322992");
  const href = url.toString();
  return { href };
};
